import ProspectorProApiService from './ProspectorProApiService';

export default class ProspectorService extends ProspectorProApiService {
  getProspectorServiceByAccountId(identifier) {
    return new Promise((resolve, reject) => {
      this.get('/ProspectorServiceREST/get-by-accountid', {}, identifier)
        .then((prospectorServiceData) => {
          resolve(prospectorServiceData);
        }, (err) => {
          // Handle the rejection caused by no prospector service
          // found for this account: it should not throw an error
          if (err.indexOf('No prospector service found ') > -1) {
            resolve(null);
          } else {
            reject(err);
          }
        });
    });
  }

  getAgentsStatus(identifier) {
    return this.get('/ProspectorServiceREST/get-agents-status', {}, identifier);
  }
}
